import { api } from "@/lib/api";
import {
  Department,
  DepartmentDtoSchema,
  departmentFromDto,
  departmentToDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import {
  getDepartmentQueryOptions,
  getDepartmentsQueryOptions,
} from "./get.hooks";

export function useUpdateDepartment(opts?: {
  onSuccess?: (department: Department) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (department: Department) => {
      const dto = departmentToDto(department);
      const result = await api.put(
        "/api/departments",
        dto,
        DepartmentDtoSchema,
      );
      return departmentFromDto(result);
    },
    onSuccess: (department) => {
      queryClient.setQueryData(getDepartmentsQueryOptions.queryKey, (old) =>
        old?.map((d) => (d.id === department.id ? department : d)),
      );
      queryClient.setQueryData(
        getDepartmentQueryOptions(department.id).queryKey,
        () => department,
      );
      toast({
        title: "toast.departmentUpdated",
        variant: "success",
      });
      opts?.onSuccess?.(department);
    },
    onError: () => {
      toast({
        title: "toast.updateDepartmentError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
